import * as React from 'react';
import { toast } from 'sonner';
import { updateProfileSchema } from '@hch/shared';
import { Button } from '~/components/ui/button';
import { Card, CardContent, Field, Input } from '~/components/ui/primitives';
import { PageHeader } from '~/components/shared/states';
import { api } from '~/lib/api';
import { useAuth } from '~/lib/auth';
import { messageOf } from '~/lib/queries';

export function ClientProfilePage() {
  const { user, refresh } = useAuth();

  const [form, setForm] = React.useState({
    firstName: user?.firstName ?? '',
    lastName: user?.lastName ?? '',
    phone: user?.phone ?? '',
  });
  const [errors, setErrors] = React.useState<Record<string, string>>({});
  const [saving, setSaving] = React.useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setErrors({});

    const parsed = updateProfileSchema.safeParse({
      ...form,
      phone: form.phone || null,
    });

    if (!parsed.success) {
      setErrors(
        Object.fromEntries(
          parsed.error.issues.map((issue) => [issue.path.join('.'), issue.message]),
        ),
      );
      return;
    }

    setSaving(true);
    try {
      await api.patch('/me', parsed.data);
      await refresh();
      toast.success('Votre fiche a ete mise a jour.');
    } catch (error) {
      toast.error(messageOf(error));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="app-page">
      <PageHeader title="Ma fiche" description="Ces informations figurent sur vos interventions." />

      <Card className="max-w-xl">
        <CardContent className="pt-6">
          <form onSubmit={submit} className="flex flex-col gap-4" noValidate>
            <Field
              label="Adresse e-mail"
              htmlFor="email"
              hint="L'adresse de connexion ne peut pas etre modifiee ici."
            >
              <Input value={user?.email ?? ''} readOnly disabled />
            </Field>

            <div className="grid gap-4 sm:grid-cols-2">
              <Field label="Prenom" htmlFor="firstName" error={errors.firstName} required>
                <Input
                  value={form.firstName}
                  onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                  autoComplete="given-name"
                />
              </Field>
              <Field label="Nom" htmlFor="lastName" error={errors.lastName} required>
                <Input
                  value={form.lastName}
                  onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                  autoComplete="family-name"
                />
              </Field>
            </div>

            <Field label="Telephone" htmlFor="phone" error={errors.phone}>
              <Input
                type="tel"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                autoComplete="tel"
                placeholder="06 12 34 56 78"
              />
            </Field>

            <Button type="submit" loading={saving} className="self-start">
              Enregistrer
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
